// ----------------------------------------------------------------------

const shape = {
  borderRadius: 2,
  borderRadiusSm: 3,
  borderRadiusMd: 4
};

export default shape;
